



























































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import MultipleInputs from '@/utils/MultipleInputs'
import { hasValue } from '@/utils/util'
import { cloneDeep } from 'lodash'
// 1 < 小于
// 2 ≦ 小于等于
// 3 > 大于
// 4 ≥ 大于等于
// 5 >< 大于-小于
// 6 ≥< 大于等于-小于
// 7 >≦ 大于-小于等于
// 8 ≥≦ 大于等于-小于等于
// 仅限制最大值或者最小值
const singleRange = ['1', '2', '3', '4']
// 同时限制最大值与最小值
const doubleRange = ['5', '6', '7', '8']
// 可添加的范围个数最大值
const MAX_NUM = 20

@Component({})
export default class RangeForm extends Vue {
	private singleRange = singleRange
	private doubleRange = doubleRange
	private rangeForm: any = {}
	private multiInstance: any = {}
	private MAX_NUM = MAX_NUM

	@Prop({})
	private index: any

	@Prop({})
	private initialVal: any

	@Watch('initialVal', { immediate: true })
	private onIntialValChange() {
		if (this.initialVal) {
			this.$nextTick(() => {
				// 处理初始值
				// const ruleDetailList = this.initialVal.ruleDetailList || []
				const ruleDetailList = this.initialVal || []
				this.multiInstance = new MultipleInputs(
					ruleDetailList.length || 1,
					MAX_NUM
				)

				this.$nextTick(() => {
					const listWithoutMin: any[] = [],
						totalList: any[] = []
					this.multiInstance.idArr.forEach((id: number, index: number) => {
						const rangeItem = ruleDetailList[index]
						listWithoutMin[id] = {
							// 先不设置minValue
							maxValue: rangeItem.maxValue,
							symbol: rangeItem.symbol,
							intervalTimes: rangeItem.intervalTimes,
						}

						totalList[id] = { ...listWithoutMin[id] }

						if (doubleRange.includes(rangeItem.symbol)) {
							totalList[id].minValue = rangeItem.minValue
						}
					})

					this.rangeForm.setFieldsValue({
						// 	icu: this.initialVal.icu === '1',
						// 	taskGenerateTime: this.initialVal.taskGenerateTime,
						// 先不设置minValue minValue需symbol确定后才渲染
						ruleDetailList: listWithoutMin,
					})

					// 设置minValue
					this.$nextTick(() => {
						this.rangeForm.setFieldsValue({
							ruleDetailList: totalList,
						})
					})
				})
			})
		}
	}

	private triggerMaxValidator(rule: any, value: any, cb: any) {
		// 当前项仅触发最后一项的校验 校验多个输入项之间的关系，仅在最后一项做校验
		// 避免所有项都出现错误提示
		const prefix = rule.field.split('.')[0]
		// 校验与当前项对应的大值
		this.rangeForm.validateFields([`${prefix}.maxValue`])
		return cb()
	}

	private maxValidator(rule: any, value: any, cb: any) {
		const prefix = rule.field.split('.')[0]
		const min = this.rangeForm.getFieldValue(`${prefix}.minValue`)
		if (hasValue(min) && hasValue(value)) {
			if (Number(value) >= Number(min)) {
				return cb()
			} else {
				return cb(new Error('最大值不可小于最小值'))
			}
		}
		return cb()
	}

	private removeItem(index: number) {
		this.multiInstance.remove(index)
	}

	private addItem(index: number) {
		const res = this.multiInstance.add()
		if (res === false) {
			this.$message.error(`区间限制${MAX_NUM}条内`)
		}
	}

	private removeCurrentForm() {
		this.$emit('removeRangeCard', this.index)
	}

	private getForm() {
		return new Promise((resolve, reject) => {
			this.rangeForm.validateFields((errors: any, values: any) => {
				if (!errors) {
					// values.icu = values.icu ? '1' : '0'
					values.ruleDetailList = values.ruleDetailList || []

					const list: any = []
					this.multiInstance.idArr.forEach((id: number) => {
						const item = values.ruleDetailList[id]
						if (singleRange.includes(item.symbol)) {
							// 仅限制最大值或最小值时，将最大值最小值设置为同等值
							item.minValue = item.maxValue
						}
						list.push(item)
					})
					// values.ruleDetailList = list

					// return resolve(values)
					return resolve(list)
				} else {
					return reject(errors)
				}
			})
		})
	}

	private created() {
		this.rangeForm = this.$form.createForm(this)
		// 初始化为一条
		this.multiInstance = new MultipleInputs(1, MAX_NUM)
	}
}
